<template>
  <v-container fluid style="height:100%; background:linear-gradient(rgb(255, 255, 255), rgb(245, 249, 250));">
    <v-row align="center" justify="center" style="height:100%;">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3">
        <v-card class="px-5 py-10" outlined>
          <v-form ref="form">
            <v-row align="center" justify="end">
              <v-col cols="auto" class="pb-0">
                <v-btn-toggle v-model="langCd" mandatory dense color="primary">
                  <v-btn small value="kor">{{ $t('login.kor') }}</v-btn>
                  <v-btn small value="eng">{{ $t('login.eng') }}</v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col>
              <v-img src="@/assets/images/hl_logo.png" width="150" style="left:50%; transform: translate(-50%);"></v-img>
              </v-col>
            </v-row>
            <v-row align="center" justify="space-between" class="mt-2">
              <v-col class="pb-0">
                <div style="color:#acacac; font-size:20px; text-align: center;">
                  <p>{{ $t('login.title') }}</p>
                </div>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col>
                <div style="color:#acacac; font-size:15px; text-align: center;">
                  <p>{{ $t('login.subtitle') }}</p>
                </div>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="pb-0">
              <v-text-field v-model="patient_id" :autofocus="true" dense outlined :placeholder="$t('login.barcodePlaceholder')" :rules="[required]"></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="py-0">
              <v-text-field v-model="patient_name" @keydown.enter="login" dense outlined :placeholder="$t('login.namePlaceholder')" :rules="[required]"></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="pt-0"><picture>
                <source media="(min-width: )" srcset="">
                <img src="" alt="">
              </picture>
              <v-btn @click="login" dark block dense :elevation="0">{{ $t('login.loginBtn') }}</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import http from '@/mixin/http'
import validation from '@/mixin/validation'
export default {
  name: 'login-vue',
  mixins: [validation, http],
  data: () => ({
    patient_id: null,
    patient_name: null,
  }),
  computed: {
    langCd: {
      get() {
        return this.$store.getters.lang_cd;
      },
      set(val) {
        this.$store.commit('setLangCd', val);
        this.$i18n.locale = val;
        localStorage.setItem('lang_cd', val);
      },
    },
  },
  created:function(){
    if ( this.$session.exists() ){
      this.$session.destroy();
    }
  },
  methods:{
    login: async function(){
      const valid = this.$refs.form.validate();
      if ( !valid ) return;

      let data = {
        patient_id: this.patient_id,
        patient_name: this.patient_name
      };
      let res = await this.post(this.$lookupUrl + '/server/login.php', data);
      if ( res ){
        if ( res.data.ret == '0000' ){
          //로그인성공
          this.$session.set('jwt', res.data.jwt);
          const query = {
            patient_id: encodeURI(this.patient_id),
            patient_name: encodeURI(this.patient_name),
          };
          this.$router.replace({name:"Progress", query});
        }
      }
    }
  }
}
</script>
